import { StateCreator } from 'zustand';
import { ExistingImage, FormImage, FormImagesSlice, NewImage } from './formImagesTypes';
import { removeItem, sortingItems } from './formImagesUtils';
import { indexedDBUtils } from '../safeIndexedDB';
import { logBlobSaveFallback } from 'src/utils/observability/logs/webview-reload/webviewReloadLogs';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

let blobKeyCounter = 0;

export const createImagesSlice: ImmerStateCreator<FormImagesSlice> = (set) => ({
    images: [],
    ADD_IMAGES: async (images, type) => {
        if (type === 'new') {
           const newImages = images as NewImage[]
           const newImagesArray: FormImage[] = await Promise.all(
             newImages.map(async (newImage, idx) => {
               if (newImage.file) {
                 const blobKey = `img_${Date.now()}_${++blobKeyCounter}_${Math.random().toString(36).substr(2, 9)}`;
                 try {
                   await indexedDBUtils.saveBlob(blobKey, newImage.file);
                   return {
                     type: 'new' as const,
                     content: {
                       ...newImage,
                       blobKey,
                       fileName: newImage.file.name,
                       mimeType: newImage.file.type,
                     }
                   };
                 } catch (error) {
                   const errorMsg = error instanceof Error ? error.message : String(error);
                   logBlobSaveFallback(newImage.file.name, idx + 1, newImages.length, errorMsg);
                   return { type: 'new' as const, content: newImage };
                 }
               }
               return { type: 'new' as const, content: newImage };
             })
           );
           set((state) => {
               state.images = [...state.images, ...newImagesArray]
           }, false, 'ADD_SELECTED_IMAGES')
        }
        else if (type === 'existing') {
            const existingImages = images as ExistingImage[]
            const existingImagesArray: FormImage[] = existingImages.map(existingImage => ({type: 'existing', content: existingImage}))
            set((state) => {
                state.images = [...state.images, ...existingImagesArray]
            }, false, 'ADD_SELECTED_IMAGES')
        }
    },
    REMOVE_IMAGE: (index: number) => {
        set((state) => {
            const imageToRemove = state.images[index];
            if (imageToRemove?.type === 'new') {
              const content = imageToRemove.content as NewImage;
              if (content.blobKey) {
                indexedDBUtils.deleteBlob(content.blobKey);
              }
            }
            const newImages = removeItem(index, state.images);
            state.images = newImages
        }, false, 'REMOVE_IMAGE')
    },
    REMOVE_IMAGES: () => {
        set((state) => {
            const hasBlobs = state.images.some(
              (img) => img.type === 'new' && (img.content as NewImage).blobKey
            );
            if (hasBlobs) {
              indexedDBUtils.clearAll();
            }
            state.images = [];
        }, false, 'REMOVE_IMAGES')
    },
    SORTING_IMAGE: ({source, destination}) => {
        set((state) => {
            const newImages  = sortingItems(source, destination, state.images);
            state.images = newImages
        }, false, 'SORTING_IMAGE')
    }
});